let api_prefix = ''

if (process.env.NODE_ENV === 'production') {
	api_prefix = '/api'
}

export let API_PREFIX = api_prefix
// Usage:
// import { API_PREFIX } from './config.js'
